import TomSelect from 'tom-select/dist/js/tom-select.base.js'
import TomSelectCheckboxOptions from 'tom-select/dist/js/plugins/checkbox_options.js'

TomSelect.define('checkbox_options', TomSelectCheckboxOptions)

up.compiler('[data-filter-select]', (element: HTMLSelectElement, { label }: { label: string }) => {
  const container = element.parentElement!
  const select = new TomSelect(element, {
    create: false,
    dropdownParent: 'body',
    plugins: ['checkbox_options'],
    render: {
      dropdown() {
        return '<div class="filter-select-dropdown"></div>'
      },
      item(_data: Record<string, unknown>, _escape: (str: string) => string) {
        return '<div></div>'
      },
    },
    onInitialize() {
      container.querySelector('.ts-wrapper')!.classList.remove('single')
    },
    onDropdownOpen(dropdown: HTMLElement) {
      const boundingRect = dropdown.getBoundingClientRect()
      if (boundingRect.left < 10) {
        dropdown.style.left = '10px'
      }
      const overflowRight = boundingRect.right - (document.body.getBoundingClientRect().right - 10)
      if (overflowRight > 0) {
        dropdown.style.left = `${boundingRect.left - overflowRight}px`
      }
    },
  })

  function updateLabels(): void {
    let selectedText = ''
    let selectedCounter: number | undefined
    if (element.selectedOptions.length === 0 || element.value === '') {
      selectedText = 'alle'
    } else if (element.selectedOptions.length === 1) {
      selectedText = element.selectedOptions[0].textContent!
    } else {
      selectedCounter = element.selectedOptions.length
    }
    const fullLabel = label ? `${label}: ${selectedText}` : selectedText
    container.style.setProperty('--label', `"${fullLabel}"`)
    if (selectedCounter) {
      container.style.setProperty('--counter', `"${selectedCounter}"`)
    } else {
      container.style.removeProperty('--counter')
    }
  }

  select.on('change', updateLabels)
  updateLabels()

  return () => {
    ;(
      element as HTMLSelectElement & { tomselect: InstanceType<typeof TomSelect> }
    ).tomselect.destroy()
  }
})
